export const SigningStatus = {
  NotSigned: 'NotSigned',
  Opened: 'Opened',
  Signed: 'Signed',
};

export type SigningStatus = (typeof SigningStatus)[keyof typeof SigningStatus];

export const DocumentStatus = {
  Draft: 'Draft',
  Pending: 'Pending',
  Completed: 'Completed',
  Rejected: 'Rejected',
  Expired: 'Expired',
} as const;

export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];

export interface AgreementDocument {
  id: string;
  provider: string;
  providerDocumentId: string;
  title: string;
  ownerType: string;
  ownerId: string;
  signerEmail: string;
  signerName: string;
  status: DocumentStatus;
  signingStatus: SigningStatus;
  signedAt: string;
  completedAt: string;
  rejectionReason: string;
  createdAt: string;
  updatedAt: string;
}

export interface TemplateFieldMeta {
  label?: string;
  placeholder?: string;
  required?: boolean;
  readOnly?: boolean;
}

export interface TemplateField {
  id: number;
  /** SIGNATURE | FREE_SIGNATURE | INITIALS | NAME | EMAIL | DATE | TEXT | NUMBER | RADIO | CHECKBOX | DROPDOWN */
  type: string;
  customText: string;
  recipientId: number;
  page: number;
  fieldMeta?: TemplateFieldMeta | null;
}
